import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { firstValueFrom } from 'rxjs';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { environment } from 'src/app/environments/environments';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-work-orders',
  templateUrl: './modal-work-orders.component.html',
  styleUrls: ['./modal-work-orders.component.css']
})
export class ModalWorkOrdersComponent {
  @Output() saveEvent = new EventEmitter<any>();

  requestForm: FormGroup;
  loadingFull: boolean = true;
  loading: any;
  created_at: string = '';
  id: string = '';
  action: string = '';
  collaborators: any = [];
  types: any = [
    { id: 1, name: 'Preventivo' },
    { id: 2, name: 'Correctivo' },
    { id: 3, name: 'Bitácora' },
  ];

  productionLineSelected: string | null = null;
  productionEquipmentSelected: string | null = null;
  productionSpecialitySelected: string | null = null;
  component_stock_verification: boolean = false;
  is_necesary_stop_line: boolean = false;
  schedule_date: string | null = null;
  collabs: any = [];
  comments_to_warehouse: string | null = null;
  id_binnacle: string | null = null;


  productionLine: any = [];
  productionEquipment: any = [];
  productionSpeciality: any = [];

  constructor(
    private fb: FormBuilder,
    public thisModalRef: MdbModalRef<ModalWorkOrdersComponent> | null = null,
    private crudService: GenericCrudService<any>
  ) {
    this.requestForm = this.fb.group({
      productionLineSelected: [null],
      productionEquipmentSelected: [null],
      productionSpecialitySelected: [null],
      problem: [null],
      component_stock_verification: [null],
      is_necesary_stop_line: [null],
      schedule_date: [null],
      collabs: [null],
      comments_to_warehouse: [null],
      type: [null],
      photo: new FormControl(null),
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      this.loadingFull = true;
      await Promise.all([
        this.getProductionLine(),
        this.getProductionSpeciality(),
        this.selectOptionsByBinnacle(),
        this.getCollaborators(),
      ]);
    } catch (error) {
      console.log('[ngOnInit] error: ', error);
    } finally {
      this.loadingFull = false;
    }
  }

  async selectOptionsByBinnacle() {
    if(this.id_binnacle) {
      this.requestForm.get('productionLineSelected')?.setValue(this.productionLineSelected);
      await this.buildProductionEquipment(this.requestForm.get('productionLineSelected')?.value);
      this.requestForm.get('productionEquipmentSelected')?.setValue(this.productionEquipmentSelected);
      this.requestForm.get('productionSpecialitySelected')?.setValue(this.productionSpecialitySelected);
    }
  }

  closeModal() {
    this.thisModalRef?.close(true);
  }

  async getProductionSpeciality(): Promise<void> {
    const body = new FormData();
    body.append('action', 'SELECT');
    body.append('table_name', 'PRODUCTION_SPECIALITY');

    try {
      const response: any = await firstValueFrom(
        this.crudService.crud(body, environment.GenericCrudOperation)
      );
      if (response && response.status === 1 && response.data) {
        this.productionSpeciality = response.data;
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  }
  
  async getProductionLine(): Promise<void> {
    const body = new FormData();
    body.append('action', 'SELECT');
    body.append('table_name', 'PRODUCTION_LINE');

    try {
      const response: any = await firstValueFrom(
        this.crudService.crud(body, environment.GenericCrudOperation)
      );
      if (response && response.status === 1 && response.data) {
        this.productionLine = response.data;
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  }

  async getProductionEquipment(id_production_line: any): Promise<boolean> {
    const body = new FormData();
    body.append('action', 'SELECT');
    body.append('table_name', 'PRODUCTION_EQUIPMENT');
    body.append('id_production_line', id_production_line);

    try {
      const response: any = await firstValueFrom(
        this.crudService.crud(body, environment.GetProductionEquipments)
      );
      if (response && response.status === 1 && response.data) {
        this.productionEquipment = response.data;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  async buildProductionEquipment(id_production_line: any): Promise<void> {
    try {
      this.loadingFull = true;
      this.requestForm.get('productionEquipmentSelected')?.disable();
      if (await this.getProductionEquipment(id_production_line)) {
        this.requestForm.get('productionEquipmentSelected')?.enable();
      }
    } catch (error) {
      console.log('error: ', error);
    } finally {
      this.loadingFull = false;
    }
  }

  async getCollaborators(): Promise<boolean> {
    const body = new FormData();
    body.append('id_company', localStorage.getItem('IdCompany') ?? '');

    try {
      const response: any = await firstValueFrom(
        this.crudService.crud(body, environment.GetCollaborators)
      );
      if (response && response.status === 1 && response.data) {
        this.collaborators = response.data;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  newRegister(): void {
    try {
      Swal.fire({
        title: 'Procesando...',
        allowOutsideClick: false,
        showCancelButton: false,
        showCloseButton: false,
        showConfirmButton: false,
        willOpen: async () => {
          Swal.showLoading();
          const body = new FormData();
          body.append('action', 'INSERT');
          body.append('table_name', 'WORK_ORDERS');

          body.append('id_production_line', this.requestForm.get('productionLineSelected')?.value);
          body.append('id_production_equipment', this.requestForm.get('productionEquipmentSelected')?.value);
          body.append('id_production_speciality', this.requestForm.get('productionSpecialitySelected')?.value);
          body.append('component_stock_verification', this.requestForm.get('component_stock_verification')?.value == true ? '1' : '0');
          body.append('is_necesary_stop_line', this.requestForm.get('is_necesary_stop_line')?.value == true ? '1' : '0');
          body.append('schedule_date', this.requestForm.get('schedule_date')?.value);
          body.append('comments_to_warehouse', this.requestForm.get('comments_to_warehouse')?.value);
          body.append('type', this.requestForm.get('type')?.value);
          body.append('collabs', this.requestForm.get('collabs')?.value);
          body.append('status', '1');
          body.append('active', '1');

          body.append('id_company', localStorage.getItem('IdCompany') ?? '');
          body.append('id_creator_user', localStorage.getItem('IdUser') ?? '');
          
          if(this.id_binnacle != null) {
            body.append('id_binnacle', this.id_binnacle ?? '');
          }
          console.log("body", body);
          const response: any = await firstValueFrom(
            this.crudService.crud(body, environment.AssignBinnacleToNewWorkOrder)
          );

          if (response && response.status === 1) {
            Swal.fire({
              icon: 'success',
              title: 'Se ha creado correctamente!',
              showConfirmButton: false,
              timer: 1500,
            });
            setTimeout(() => {
              this.saveEvent.emit(true);
              this.closeModal();
            }, 2000);
          }
        },
      });

    } catch (error) {
      console.error('Error: ', error);
    }
  }
}
